/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CandidateDTO } from '../models/CandidateDTO'
import type { CandidatePatchDTO } from '../models/CandidatePatchDTO'
import type { PaginatedDTO_CandidateIndexDTO_ } from '../models/PaginatedDTO_CandidateIndexDTO_'
import type { StatusOptionsResponseDTO } from '../models/StatusOptionsResponseDTO'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class AspenCandidatesService {
    /**
     * Export Candidates
     * Export all matching candidates as a CSV file.
     * Supports the same filters as the candidates list endpoint.
     * No pagination — streams all matching records.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static exportCandidatesCandidatesExportGet({
        status,
        firstName,
        lastName,
        referrerId,
        sort,
        search,
        createdAfter,
        createdBefore,
        uncontactedOnly = false,
        patientManagerId,
        carePartnerId,
        preferredContactAfter,
        preferredContactBefore,
        hasPreferredContactTime
    }: {
        /**
         * Filter by status. Repeat the param to match any of several, mirroring the candidates list endpoint so an export can reproduce exactly what the worklist is showing.
         */
        status?: Array<
            | 'candidate'
            | 'in_contact'
            | 'registered'
            | 'allocated'
            | 'allocated_group_2'
            | 'allocated_group_3'
            | 'record_retrieval'
            | 'screen_failure'
            | 'undecided'
            | 'declined'
            | 'unreachable'
            | 'duplicate'
        > | null
        /**
         * Filter by First Name
         */
        firstName?: string | null
        /**
         * Filter by Last Name
         */
        lastName?: string | null
        /**
         * Filter by Referrer ID
         */
        referrerId?: string | null
        /**
         * Sort results by 'field[:asc|desc]'. Defaults to 'asc'. Example: 'name:desc', 'created_at'.
         */
        sort?: string | null
        /**
         * Search term
         */
        search?: string | null
        /**
         * Filter candidates created after this date
         */
        createdAfter?: string | null
        /**
         * Filter candidates created before this date
         */
        createdBefore?: string | null
        /**
         * Filter to show only candidates with no contact attempts
         */
        uncontactedOnly?: boolean
        /**
         * Filter candidates by patient manager ID
         */
        patientManagerId?: string | null
        /**
         * Filter candidates by care partner ID
         */
        carePartnerId?: string | null
        /**
         * Filter candidates whose preferred contact window overlaps a range starting at this ISO datetime
         */
        preferredContactAfter?: string | null
        /**
         * Filter candidates whose preferred contact window overlaps a range ending at this ISO datetime
         */
        preferredContactBefore?: string | null
        /**
         * When true, only candidates with a stated preferred contact time; when false, only candidates without one
         */
        hasPreferredContactTime?: boolean | null
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/candidates/export',
            query: {
                status: status,
                first_name: firstName,
                last_name: lastName,
                referrer_id: referrerId,
                sort: sort,
                search: search,
                created_after: createdAfter,
                created_before: createdBefore,
                uncontacted_only: uncontactedOnly,
                patient_manager_id: patientManagerId,
                care_partner_id: carePartnerId,
                preferred_contact_after: preferredContactAfter,
                preferred_contact_before: preferredContactBefore,
                has_preferred_contact_time: hasPreferredContactTime
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Get Status Options
     * Get every status option for the frontend dropdown.
     *
     * Each entry carries an ``actionable`` flag marking the statuses that need
     * coordinator attention, so a worklist can default to them without the
     * frontend hard-coding its own copy of that set.
     * @returns StatusOptionsResponseDTO Successful Response
     * @throws ApiError
     */
    public static getStatusOptionsCandidatesStatusOptionsGet(): CancelablePromise<StatusOptionsResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/candidates/status-options'
        })
    }
    /**
     * Get Filter Options
     * Get available filter options for the candidates endpoint.
     *
     * Returns:
     * dict: Available filter options including date ranges and other filter types
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getFilterOptionsCandidatesFilterOptionsGet(): CancelablePromise<Record<string, Array<Record<string, string>>>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/candidates/filter-options'
        })
    }
    /**
     * Index
     * Get a paginated list of Aspen Patient Candidates.
     *
     * Supports filtering by:
     * - Date range (created_after, created_before for flexible date filtering)
     * - Contact status (uncontacted_only)
     * - Patient manager ID (patient_manager_id)
     * - Care partner ID (care_partner_id)
     * - Preferred contact window (preferred_contact_after, preferred_contact_before)
     * - Preferred contact presence (has_preferred_contact_time)
     * - Standard filters (status, name, etc.)
     * - One or more statuses (repeat ?status=), e.g. the actionable worklist set
     *
     * Filters can be combined for compound logic (e.g., candidates created in last 7 days and uncontacted).
     * @returns PaginatedDTO_CandidateIndexDTO_ Successful Response
     * @throws ApiError
     */
    public static indexCandidatesGet({
        page = 1,
        limit = 10,
        status,
        firstName,
        lastName,
        referrerId,
        sort,
        search,
        createdAfter,
        createdBefore,
        uncontactedOnly = false,
        patientManagerId,
        carePartnerId,
        preferredContactAfter,
        preferredContactBefore,
        hasPreferredContactTime,
        appointmentAfter,
        appointmentBefore,
        appointmentStatus,
        hasAppointment
    }: {
        /**
         * Page number for pagination, starting at 1
         */
        page?: number
        /**
         * Number of items per page, maximum 1000
         */
        limit?: number
        /**
         * Filter by status. Repeat the param to match any of several, e.g. ?status=candidate&status=in_contact. Valid values: candidate, in_contact, registered, allocated, allocated_group_2, allocated_group_3, record_retrieval, screen_failure, undecided, declined, unreachable, duplicate.
         */
        status?: Array<
            | 'candidate'
            | 'in_contact'
            | 'registered'
            | 'allocated'
            | 'allocated_group_2'
            | 'allocated_group_3'
            | 'record_retrieval'
            | 'screen_failure'
            | 'undecided'
            | 'declined'
            | 'unreachable'
            | 'duplicate'
        > | null
        /**
         * Filter by First Name
         */
        firstName?: string | null
        /**
         * Filter by Last Name
         */
        lastName?: string | null
        /**
         * Filter by Referrer ID
         */
        referrerId?: string | null
        /**
         * Sort results by 'field[:asc|desc]'. Defaults to 'asc'. Example: 'name:desc', 'created_at'.
         */
        sort?: string | null
        /**
         * Search term
         */
        search?: string | null
        /**
         * Filter candidates created after this date
         */
        createdAfter?: string | null
        /**
         * Filter candidates created before this date
         */
        createdBefore?: string | null
        /**
         * Filter to show only candidates with no contact attempts
         */
        uncontactedOnly?: boolean
        /**
         * Filter candidates by patient manager ID
         */
        patientManagerId?: string | null
        /**
         * Filter candidates by care partner ID
         */
        carePartnerId?: string | null
        /**
         * Filter candidates whose preferred contact window overlaps a range starting at this ISO datetime
         */
        preferredContactAfter?: string | null
        /**
         * Filter candidates whose preferred contact window overlaps a range ending at this ISO datetime
         */
        preferredContactBefore?: string | null
        /**
         * When true, only candidates with a stated preferred contact time; when false, only candidates without one
         */
        hasPreferredContactTime?: boolean | null
        /**
         * Only candidates whose appointment starts at or after this
         */
        appointmentAfter?: string | null
        /**
         * Only candidates whose appointment starts at or before this
         */
        appointmentBefore?: string | null
        /**
         * Appointment statuses to include. Repeatable, so a coordinator can ask for confirmed and completed together
         */
        appointmentStatus?: Array<string> | null
        /**
         * When true, only candidates with a booked appointment; when false, only those without one — which is how you find pre-scheduler registrations that still need handling
         */
        hasAppointment?: boolean | null
    }): CancelablePromise<PaginatedDTO_CandidateIndexDTO_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/candidates',
            query: {
                page: page,
                limit: limit,
                status: status,
                first_name: firstName,
                last_name: lastName,
                referrer_id: referrerId,
                sort: sort,
                search: search,
                created_after: createdAfter,
                created_before: createdBefore,
                uncontacted_only: uncontactedOnly,
                patient_manager_id: patientManagerId,
                care_partner_id: carePartnerId,
                preferred_contact_after: preferredContactAfter,
                preferred_contact_before: preferredContactBefore,
                has_preferred_contact_time: hasPreferredContactTime,
                appointment_after: appointmentAfter,
                appointment_before: appointmentBefore,
                appointment_status: appointmentStatus,
                has_appointment: hasAppointment
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Get
     * Get a single Aspen Patient Candidate by id.
     * @returns CandidateDTO Successful Response
     * @throws ApiError
     */
    public static getCandidatesCandidateIdGet({ candidateId }: { candidateId: string }): CancelablePromise<CandidateDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/candidates/{candidate_id}',
            path: {
                candidate_id: candidateId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Patch
     * Update an Aspen Patient Candidate.
     * Automatically logs all field changes to the audit trail.
     * @returns CandidateDTO Successful Response
     * @throws ApiError
     */
    public static patchCandidatesCandidateIdPatch({
        candidateId,
        requestBody
    }: {
        candidateId: string
        requestBody: CandidatePatchDTO
    }): CancelablePromise<CandidateDTO> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/aspen/candidates/{candidate_id}',
            path: {
                candidate_id: candidateId
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Delete
     * Delete an Aspen Patient Candidate.
     * Automatically logs deletion to the audit trail.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static deleteCandidatesCandidateIdDelete({ candidateId }: { candidateId: string }): CancelablePromise<Record<string, string>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/aspen/candidates/{candidate_id}',
            path: {
                candidate_id: candidateId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Record Calendar Download
     * Record that the current user downloaded a calendar invite for this candidate.
     * Each call creates a new audit entry so the full download history is preserved.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static recordCalendarDownloadCandidatesCandidateIdCalendarDownloadsPost({
        candidateId
    }: {
        candidateId: string
    }): CancelablePromise<Record<string, string>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/candidates/{candidate_id}/calendar-downloads',
            path: {
                candidate_id: candidateId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Get Valid Status Transitions
     * Get valid status transitions for a specific candidate.
     * Returns the current status and actionable statuses for the dropdown.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getValidStatusTransitionsCandidatesCandidateIdValidStatusesGet({
        candidateId
    }: {
        candidateId: string
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/candidates/{candidate_id}/valid-statuses',
            path: {
                candidate_id: candidateId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Update Candidate Status
     * Update candidate status to any valid value.
     * Allows changing status at any time - useful for cases like patient was unreachable but later contacts us.
     * Automatically logs status changes to the audit trail.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static updateCandidateStatusCandidatesCandidateIdStatusPatch({
        candidateId,
        newStatus
    }: {
        candidateId: string
        newStatus: string
    }): CancelablePromise<Record<string, string>> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/aspen/candidates/{candidate_id}/status',
            path: {
                candidate_id: candidateId
            },
            query: {
                new_status: newStatus
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
}
